import { render, staticRenderFns } from "./project_add.vue?vue&type=template&id=5d9d942b&scoped=true&"
import script from "./project_add.vue?vue&type=script&lang=js&"
export * from "./project_add.vue?vue&type=script&lang=js&"
import style0 from "./project_add.vue?vue&type=style&index=0&id=5d9d942b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9d942b",
  null
  
)

export default component.exports